
import 'whatwg-fetch';


import {Promise} from "es6-promise";

function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}


var ContactSource = {

  contactMe: function (availability) {


    var address;
    if(Object.keys(availability.qualified_address).length) {
      address = availability.qualified_address;
    }
    else {
      address = {
        address: availability.input_address.streetAddress,
        unit: availability.input_address.secondary,
        city: availability.input_address.city,
        state: availability.input_address.state,
        zip: availability.input_address.zip
      }
    }

    var request = new Request(availability.api_path+'?do=rescontactme', {
      method: 'POST', 
      mode: 'cors', 
      redirect: 'follow',
      headers: new Headers({
        'Content-Type': 'application/json; charset=UTF-8'
      }),
      body: JSON.stringify({
        address: address.address,
        unit: address.unit,
        zip: address.zip,

        service_type: availability.input_address.serviceType,
        sso_user: availability.sso_user,

        interested_in: availability.contact_info.interested_in,
        monthly_budget: availability.contact_info.monthly_budget,
        industry: availability.contact_info.industry,
        comments: availability.contact_info.comments,

        first_name: availability.contact_info.first_name,
        last_name: availability.contact_info.last_name,
        email: availability.contact_info.email_address,
        phone: ('undefined' !== typeof availability.contact_info.phone_number) ? availability.contact_info.phone_number : '',

        workstations: ('undefined' !== typeof availability.contact_info.workstations) ? availability.contact_info.workstations : '',
        phones: ('undefined' !== typeof availability.contact_info.phones) ? availability.contact_info.phones : '',
        company_name: ('undefined' !== typeof availability.contact_info.company_name) ? availability.contact_info.company_name : '',


        prequal_tracking_key: ('undefined' !== typeof availability.prequal_tracking_key) ? availability.prequal_tracking_key : '',

        contact_type: availability.contact_info.contact_type

      })
    });

    return fetch(request)
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if(json.status && json.status == 'ERR') {
          throw new Exception (JSON.stringify(json));
        }
        return json;
      })
      .catch(function(ex) {
        return [{error: ex.message}];
      });

  }
}

export default  ContactSource;